module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.hidePanel) ? _c('edit-pane', {
    ref: "od",
    attrs: {
      "title": _vm.form.name,
      "editable": _vm.isManager('project|maintenance|property|finance|management|admin') ? true : false,
      "is-edit": _vm.editMode
    },
    on: {
      "save": _vm.onSave,
      "cancel": _vm.onCancel,
      "edit": _vm.onEdit,
      "add": _vm.onSave
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "orgDetailsForm",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-tabs', [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v(" Main")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('text-input', {
    attrs: {
      "prop": "name",
      "label": "Name",
      "required": "",
      "placeholder": "Organisation Name",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('text-input', {
    attrs: {
      "prop": "shortName",
      "label": "shortName",
      "required": "",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.shortName),
      callback: function($$v) {
        _vm.$set(_vm.form, "shortName", $$v)
      },
      expression: "form.shortName"
    }
  })], 1), _vm._v(" "), (_vm.isContractor) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(!_vm.disabled) ? _c('el-transfer', {
    attrs: {
      "titles": ['All Sub. Cat.', 'Sub. Cat.'],
      "data": _vm.subCatRoles
    },
    on: {
      "change": _vm.changeSubCat
    },
    model: {
      value: (_vm.subCat),
      callback: function($$v) {
        _vm.subCat = $$v
      },
      expression: "subCat"
    }
  }) : _c('el-form-item', {
    attrs: {
      "label": "Sub Categories"
    }
  }, _vm._l((_vm.subCat), function(role, i) {
    return _c('span', {
      key: i
    }, [_c('el-tag', [_vm._v("\n                     " + _vm._s(role) + "\n                   ")]), _vm._v(" \n                 ")], 1)
  }), 0)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('text-input', {
    attrs: {
      "prop": "registrationNo",
      "label": "Reg. No.",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.registrationNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "registrationNo", $$v)
      },
      expression: "form.registrationNo"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('color-picker', {
    attrs: {
      "label": "Colour",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.colourCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "colourCode", $$v)
      },
      expression: "form.colourCode"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('check-box', {
    attrs: {
      "prop": "canViewAllSites",
      "label": "",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.canViewAllSites),
      callback: function($$v) {
        _vm.$set(_vm.form, "canViewAllSites", $$v)
      },
      expression: "form.canViewAllSites"
    }
  }, [_vm._v("\n                Allow View ALL Sites?\n              ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('text-input', {
    attrs: {
      "prop": "phone",
      "label": "Phone",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('text-input', {
    attrs: {
      "prop": "email",
      "label": "E-Mail",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('text-input', {
    attrs: {
      "prop": "website",
      "label": "Web Site",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.website),
      callback: function($$v) {
        _vm.$set(_vm.form, "website", $$v)
      },
      expression: "form.website"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('text-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "prop": "address",
      "label": "Address",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1)], 1)], 1), _vm._v(" "), (!_vm.form.canViewAllSites) ? _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-broadcast-tower"
  }), _vm._v(" Sites")]), _vm._v(" "), (_vm.form.category !== 'Contractor') ? _c('div', [_c('sites-table', {
    attrs: {
      "params": {
        orgId: _vm.form.id,
        orgCategory: _vm.form.category
      },
      "title": 'Sites for ' + (_vm.form.shortName ? _vm.form.shortName : _vm.form.name),
      "show-status": false
    }
  })], 1) : _c('div', [_c('org-sites-table', {
    attrs: {
      "org-id": _vm.rowData.id,
      "category": _vm.form.category
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-file-alt"
  }), _vm._v(" Contacts")]), _vm._v(" "), _c('contacts-table', {
    attrs: {
      "org-id": _vm.rowData.id,
      "org-badge": _vm.rowData
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-file-alt"
  }), _vm._v(" Attachments")]), _vm._v(" "), _c('files-panel', {
    attrs: {
      "type": "organisation",
      "id": _vm.form.id,
      "disabled": _vm.disabled
    }
  })], 1), _vm._v(" "), (_vm.canAccess('finance')) ? _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-university"
  }), _vm._v(" Financials")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "beneficiaryName1",
      "label": "Beneficiary #1"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.beneficiaryName1),
      callback: function($$v) {
        _vm.$set(_vm.form, "beneficiaryName1", $$v)
      },
      expression: "form.beneficiaryName1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "beneficiaryName2",
      "label": "Beneficiary #2",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.beneficiaryName2),
      callback: function($$v) {
        _vm.$set(_vm.form, "beneficiaryName2", $$v)
      },
      expression: "form.beneficiaryName2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "registrationNo1",
      "label": "Reg. No. #1"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.registrationNo1),
      callback: function($$v) {
        _vm.$set(_vm.form, "registrationNo1", $$v)
      },
      expression: "form.registrationNo1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "registrationNo2",
      "label": "Reg. No. #2"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.registrationNo2),
      callback: function($$v) {
        _vm.$set(_vm.form, "registrationNo2", $$v)
      },
      expression: "form.registrationNo2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "bankName1",
      "label": "Bank #1"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.bankName1),
      callback: function($$v) {
        _vm.$set(_vm.form, "bankName1", $$v)
      },
      expression: "form.bankName1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "bankName2",
      "label": "Bank #2"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.bankName2),
      callback: function($$v) {
        _vm.$set(_vm.form, "bankName2", $$v)
      },
      expression: "form.bankName2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "bankAccount1",
      "label": "Bank Acc. #1"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.bankAccount1),
      callback: function($$v) {
        _vm.$set(_vm.form, "bankAccount1", $$v)
      },
      expression: "form.bankAccount1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "bankAccount2",
      "label": "Bank Acc. #2"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.bankAccount2),
      callback: function($$v) {
        _vm.$set(_vm.form, "bankAccount2", $$v)
      },
      expression: "form.bankAccount2"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.active > 0) ? _c('el-tab-pane', {
    attrs: {
      "lazy": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-asterisk"
  }), _vm._v(" Activity")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 12,
      "type": "flex"
    }
  }, [(_vm.form.stats.sharers > 0) ? _c('el-col', [_c('el-card', {
    staticClass: "semi-transparent",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Site",
      "icon": "fa fa-broadcast-tower",
      "value": _vm.form.stats.sharers,
      "color": "darkgrey"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.stats.actions > 0) ? _c('el-col', [_c('el-card', {
    staticClass: "semi-transparent",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Request",
      "icon": "fa fa-asterisk",
      "value": _vm.form.stats.actions,
      "color": "indianred"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.stats.assets > 0) ? _c('el-col', [_c('el-card', {
    staticClass: "semi-transparent",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Asset",
      "icon": "fa fa-cogs",
      "value": _vm.form.stats.assets,
      "color": "slateblue"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.stats.backhaul_cust > 0) ? _c('el-col', [_c('el-card', {
    staticClass: "semi-transparent",
    attrs: {
      "shadow": "hover"
    }
  }, [(_vm.form.stats.backhaul_cust > 0) ? _c('dash-text', {
    attrs: {
      "caption": "Customer",
      "icon": "fa fa-wifi",
      "value": _vm.form.stats.backhaul_cust,
      "color": "navy",
      "no-plural": ""
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.stats.backhaul_prov > 0) ? _c('el-col', [_c('el-card', {
    staticClass: "semi-transparent",
    attrs: {
      "shadow": "hover"
    }
  }, [(_vm.form.stats.backhaul_prov > 0) ? _c('dash-text', {
    attrs: {
      "caption": "Provider",
      "icon": "fa fa-wifi",
      "value": _vm.form.stats.backhaul_prov,
      "color": "navy",
      "no-plural": ""
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.stats.candidate_supplier > 0) ? _c('el-col', [_c('el-card', {
    staticClass: "semi-transparent",
    attrs: {
      "shadow": "hover"
    }
  }, [(_vm.form.stats.candidate_supplier > 0) ? _c('dash-text', {
    attrs: {
      "caption": "Candidate",
      "icon": "fa fa-broadcast-tower",
      "value": _vm.form.stats.candidate_supplier,
      "color": "goldenrod",
      "no-plural": ""
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.stats.site_contractor > 0) ? _c('el-col', [_c('el-card', {
    staticClass: "semi-transparent",
    attrs: {
      "shadow": "hover"
    }
  }, [(_vm.form.stats.site_contractor > 0) ? _c('dash-text', {
    attrs: {
      "caption": "Site Contractor",
      "icon": "fa fa-broadcast-tower",
      "value": _vm.form.stats.site_contractor,
      "color": "goldenrod",
      "no-plural": ""
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.stats.insurance > 0) ? _c('el-col', [_c('el-card', {
    staticClass: "semi-transparent",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Insurance",
      "icon": "fa fa-shield-alt",
      "value": _vm.form.stats.insurance,
      "color": "slategrey",
      "no-plural": ""
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.stats.permits > 0) ? _c('el-col', [_c('el-card', {
    staticClass: "semi-transparent",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Permit",
      "icon": "fa fa-clipboard",
      "value": _vm.form.stats.permits,
      "color": "darkgrey"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.stats.structures > 0) ? _c('el-col', [_c('el-card', {
    staticClass: "semi-transparent",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Structure",
      "icon": "fa fa-broadcast-tower",
      "value": _vm.form.stats.structures,
      "color": "indigo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.stats.tickets > 0) ? _c('el-col', [_c('el-card', {
    staticClass: "semi-transparent",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Ticket",
      "icon": "fa fa-headset",
      "value": _vm.form.stats.tickets,
      "color": "darkorange"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.stats.tenancy > 0) ? _c('el-col', [_c('el-card', {
    staticClass: "semi-transparent",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Tenancy",
      "icon": "fa fa-home",
      "value": _vm.form.stats.tenancy,
      "color": "darkgreen",
      "no-plural": ""
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.stats.tickets_cont > 0) ? _c('el-col', [_c('el-card', {
    staticClass: "semi-transparent",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Contractor",
      "icon": "fa fa-headset",
      "value": _vm.form.stats.tickets_cont,
      "color": "darkorange",
      "no-plural": ""
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.stats.workflow > 0) ? _c('el-col', [_c('el-card', {
    staticClass: "semi-transparent",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Workflow",
      "icon": "fa fa-list",
      "value": _vm.form.stats.workflow,
      "color": "indianred"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.isSuper() && !(_vm.rowData.category.indexOf('Xolas-Client') > 0)) ? _c('el-col', {
    attrs: {
      "span": 24,
      "align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "1em"
    },
    attrs: {
      "icon": "fa fa-trash",
      "size": "large",
      "type": "danger",
      "disabled": _vm.isViewOnly()
    },
    on: {
      "click": function($event) {
        return _vm.deleteEntry()
      }
    }
  }, [_vm._v("\n             Delete ALL\n           ")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Remarks")]), _vm._v(" "), _c('html-input', {
    attrs: {
      "label": "Remarks",
      "show-empty-message": true,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.remarks),
      callback: function($$v) {
        _vm.$set(_vm.form, "remarks", $$v)
      },
      expression: "form.remarks"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "4.17rem"
    }
  }), _vm._v(" "), _c('el-row', {
    staticClass: "bg-bordered",
    attrs: {
      "gutter": 16,
      "align": "left"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 8
    }
  }, [_vm._v("\n        ID: "), _c('b', [_vm._v(_vm._s(_vm.form.id))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 8,
      "align": "center"
    }
  }, [(_vm.form.updated_at) ? _c('span', [_vm._v("Updated: "), _c('b', [_vm._v(_vm._s(_vm.formatDateTime(_vm.form.updated_at)))]), (_vm.form.updated_by) ? _c('span', [_vm._v(" by "), _c('b', [_vm._v(_vm._s(_vm.form.updated_by))])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8,
      "lg": 8,
      "align": "right"
    }
  }, [_vm._v("\n        Created: "), _c('b', [_vm._v(_vm._s(_vm.formatDateTime(_vm.form.created_at)))]), (_vm.form.created_by) ? _c('span', [_vm._v(" by "), _c('b', [_vm._v(_vm._s(_vm.form.created_by))])]) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-244cf3d3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/details/OrgDetail.vue
// module id = 1373
// module chunks = 0